import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { JobService } from '../../services/job.service';
import { QuoteSummary } from '../../../quote/models/quote.summary.interface';
import { QuoteService } from '../../../quote/services/quote.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ChangeOrderComponent } from '../change.order.component';

@Component({
  selector: 'app-change-order-mobile',
  templateUrl: './change.order.mobile.component.html',
  styleUrls: ['./change.order.mobile.component.scss']
})
export class ChangeOrderMobileComponent extends ChangeOrderComponent {

}
